// StudentLayout.jsx
import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate, matchPath, useParams } from "react-router-dom";
import axios from "axios";
import apiKey from "../../config/apiKey";

import Dashboard from "../../pages/StudentDashboard/Dashboard/Dashboard";
import SideNav from "../../pages/StudentDashboard/SideBar/SideNav";
import Notification from "../../pages/StudentDashboard/Notification/Notification";
import TopBar from "../../pages/StudentDashboard/SideBar/TopBar";
import NewNotification from "../../pages/StudentDashboard/Notification/NewNotification";
import UnreadNotification from "../../pages/StudentDashboard/Notification/UnreadNotification";
import HomeProfile from "../../pages/StudentDashboard/Home/HomeProfile";
import FindTeacher from "../../pages/StudentDashboard/FindTeacher/FindTeacher";
import HomeTution from "../../pages/StudentDashboard/FindTeacher/HomeTution";
import HomeTeacherList from "../../pages/StudentDashboard/FindTeacher/HomeTeacherList";
import OnlineTeacherList from "../../pages/StudentDashboard/FindTeacher/OnlineTeacherList";
import TeacherPortfolio from "../../pages/StudentDashboard/FindTeacher/TeacherProtfolio";
import TeacherPortfolio2 from "../../pages/StudentDashboard/FindTeacher/TeacherPortfolio2";
import HomeTeacherPortfolio from "../../pages/StudentDashboard/FindTeacher/HomeTeacherPortfolio";
import HomeTeacherPortfolio2 from "../../pages/StudentDashboard/FindTeacher/HomeTeacherProtfolio2";
import StudentPayment from "../../pages/StudentDashboard/Home/StudentPayment";
import PaymentDetail from "../../pages/StudentDashboard/Home/PaymentDetail";
import TeacherList from "../../pages/StudentDashboard/Home/TeacherList";
import Report from "../../pages/StudentDashboard/Report/Report";
import MyTutoring from "../../pages/StudentDashboard/MyToturing/MyTutoring";
import Profile from "../../pages/StudentDashboard/Dashboard/Profile";
import OnlineTutionn from "../../pages/StudentDashboard/FindTeacher/OnlineTutionn";
import ChatMsg from "../../pages/StudentDashboard/MessageChat/ChatMsg";
import ZoomMeetingPageStd from "../../pages/StudentDashboard/Meeting/ZoomMeetingPageStd";
import PaymentPage from "../../pages/StudentDashboard/FindTeacher/PaymentPage";
import PaymentFailedPage from "../../pages/StudentDashboard/FindTeacher/PaymentFailed";
import CabilAIChat from "../../pages/AdminDashboard/Ad-StudentDashboard/Aichat";

// `<Navigate to>` takes a literal path, not a route pattern — it can't
// substitute a `:param` placeholder itself, so param-carrying redirects need
// a tiny wrapper that reads the actual matched value and rebuilds the target.
function RedirectWithParam({ to, param }) {
  const params = useParams();
  return <Navigate to={to.replace(`:${param}`, params[param])} replace />;
}

function StudentLayout() {
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [chatUser, setChatUser] = useState(null);        // <-- NEW
  const [chatUserLoading, setChatUserLoading] = useState(true); // <-- NEW
  const navigate = useNavigate();

  const HEADER_PX = 64;
  const FULL_HEIGHT_ROUTES = [];

  const wantsFullHeight = FULL_HEIGHT_ROUTES.some((pattern) =>
    matchPath({ path: pattern, end: false }, pathname)
  );

  const toggleSidebar = () => {
    if (window.innerWidth <= 1280) setIsSidebarOpen((s) => !s);
  };

  useEffect(() => {
    const onResize = () => setIsSidebarOpen(window.innerWidth > 1280);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // auth gate
  useEffect(() => {
    window.scrollTo(0, 0);
    const u = JSON.parse(localStorage.getItem("edo-student"));
    if (!u) navigate("/login/mentor-login");
  }, [navigate, pathname]);

  // ===== FETCH & MAP for CabilAIChat user prop =====
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("edo-student"));
    if (!stored?.student?.id || !stored?.token) {
      setChatUserLoading(false);
      return;
    }
    const uid = stored.student.id;
    const token = stored.token;

    setChatUserLoading(true);

    // helpers
    const arr = (v) => (Array.isArray(v) ? v : typeof v === "string" && v.trim()
      ? v.split(",").map(s => s.trim()).filter(Boolean)
      : []);

    const mapUserType = (t) => {
      // normalize to undergrad | grad | professional
      const s = String(t || "").toLowerCase();
      if (["undergrad","undergraduate"].includes(s)) return "undergrad";
      if (["grad","graduate"].includes(s)) return "grad";
      if (["pro","professional"].includes(s)) return "professional";
      return "undergrad"; // sensible default
    };

    Promise.all([
      axios.get(`${apiKey}/api/edolutions/student/getuser/${uid}`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      axios.get(`${apiKey}/api/edolutions/student/student-profile`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    ])
      .then(([userRes, profRes]) => {
        const userRow = userRes.data || {};
        const p = (profRes.data && profRes.data[0]) ? profRes.data[0] : {};

        const name =
          (userRow.name && String(userRow.name)) ||
          (p.first_name || p.last_name ? `${p.first_name || ""} ${p.last_name || ""}`.trim() : "Student");

        const chatUserObj = {
          user_id: String(uid),             // keep as string
          user_name: name,                  // display name
          profile: {
            name,
            email: p.email || stored?.student?.email || "",
            // WS may read this; set a reasonable default:
            user_type: mapUserType(p.user_type || userRow?.user_type),
            degree_subject: p.degree_subject || "",
            years_experience: (p.years_experience ?? 0),
            experience: p.experience_summary || "",
            skills: arr(p.skills),          // ensure array of strings
            university: p.university || p.institute || "",
            // add anything else your bot benefits from:
            country: p.country || "",
            city: p.city || "",
            class_id: p.class_id || null,
          },
        };

        setChatUser(chatUserObj);
      })
      .catch((e) => {
        console.error("chat user build error:", e);
        // fallback minimal user so chat still opens
        setChatUser({
          user_id: String(uid),
          user_name: stored?.student?.name || "Student",
          profile: {
            name: stored?.student?.name || "Student",
            user_type: "undergrad",
            degree_subject: "",
            years_experience: 0,
            experience: "",
            skills: [],
          },
        });
      })
      .finally(() => setChatUserLoading(false));
  }, []);

  return (
    <div className="min-h-screen w-full bg-white">
      <div className="h-1 w-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
      <TopBar toggleSidebar={toggleSidebar} totalUnreadCount={totalUnreadCount} />

      <div className={`flex ${wantsFullHeight ? `h-[calc(100vh-${HEADER_PX}px)] overflow-hidden` : ""}`}>
        <SideNav isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <main className={`${wantsFullHeight ? "flex-1 h-full min-h-0 overflow-hidden" : "flex-1"} w-full px-3 md:px-4 lg:px-6 py-4`}>
          <Routes>
            <Route path="/notification" element={<Notification />} />
            <Route path="/new-notification" element={<NewNotification />} />
            <Route path="/unread-notification" element={<UnreadNotification />} />
            <Route path="/mentee-chat" element={<ChatMsg setTotalUnreadCount={setTotalUnreadCount} />} />
            <Route path="" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />

            {/* AI Chat route now uses fetched chatUser */}
            <Route
              path="/ai-chat"
              element={
                chatUserLoading ? (
                  <div className="grid place-items-center h-[60vh]">
                    <div className="flex items-center gap-3 text-gray-600">
                      <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0a12 12 0 00-12 12h4z"/>
                      </svg>
                      <span>Loading chat…</span>
                    </div>
                  </div>
                ) : (
                  <CabilAIChat
                    user={chatUser}
                    wsBase="wss://ai.cabil.co/ws/qa_chat"
                    includeDateSuffix={false}
                  />
                )
              }
            />

            <Route path="/my-sessions" element={<MyTutoring />} />
            <Route path="/zoom-meeting-page-std" element={<ZoomMeetingPageStd />} />
            <Route path="/find-teacher" element={<FindTeacher />} />
            <Route path="/home-tution" element={<HomeTution />} />
            <Route path="/find-sessions" element={<OnlineTutionn />} />
            <Route path="/online-mentor-list" element={<OnlineTeacherList />} />
            <Route path="/home-teacher-list" element={<HomeTeacherList />} />
            <Route path="/mentor-portfolio/:id" element={<TeacherPortfolio />} />
            <Route path="/mentor-portfolio-2" element={<TeacherPortfolio2 />} />
            <Route path="/home-teacher-portfolio/:id" element={<HomeTeacherPortfolio />} />
            <Route path="/home-teacher-portfolio-2" element={<HomeTeacherPortfolio2 />} />
            <Route path="/pay-fees" element={<PaymentPage />} />
            <Route path="/payment-failed" element={<PaymentFailedPage />} />
            <Route path="/student-report" element={<Report />} />
            <Route path="/pro-setting" element={<HomeProfile />} />
            <Route path="/student-payment" element={<StudentPayment />} />
            <Route path="/payment-detail" element={<PaymentDetail />} />
            <Route path="/teacher-list" element={<TeacherList />} />

            {/* Kebab-case migration redirects — keep old bookmarks/links working */}
            <Route path="/newNotification" element={<Navigate to="/mentees/new-notification" replace />} />
            <Route path="/unreadNotification" element={<Navigate to="/mentees/unread-notification" replace />} />
            <Route path="/menteeChat" element={<Navigate to="/mentees/mentee-chat" replace />} />
            <Route path="/AiChat" element={<Navigate to="/mentees/ai-chat" replace />} />
            <Route path="/mySessions" element={<Navigate to="/mentees/my-sessions" replace />} />
            <Route path="/ZoomMeetingPageStd" element={<Navigate to="/mentees/zoom-meeting-page-std" replace />} />
            <Route path="/findTeacher" element={<Navigate to="/mentees/find-teacher" replace />} />
            <Route path="/homeTution" element={<Navigate to="/mentees/home-tution" replace />} />
            <Route path="/findSessions" element={<Navigate to="/mentees/find-sessions" replace />} />
            <Route path="/onlineMentorList" element={<Navigate to="/mentees/online-mentor-list" replace />} />
            <Route path="/homeTeacherList" element={<Navigate to="/mentees/home-teacher-list" replace />} />
            <Route path="/mentorPortfolio/:id" element={<RedirectWithParam to="/mentees/mentor-portfolio/:id" param="id" />} />
            <Route path="/mentorPortfolio2" element={<Navigate to="/mentees/mentor-portfolio-2" replace />} />
            <Route path="/homeTeacherPortfolio/:id" element={<RedirectWithParam to="/mentees/home-teacher-portfolio/:id" param="id" />} />
            <Route path="/homeTeacherPortfolio2" element={<Navigate to="/mentees/home-teacher-portfolio-2" replace />} />
            <Route path="/studentReport" element={<Navigate to="/mentees/student-report" replace />} />
            <Route path="/proSetting" element={<Navigate to="/mentees/pro-setting" replace />} />
            <Route path="/studentPayment" element={<Navigate to="/mentees/student-payment" replace />} />
            <Route path="/paymentDetail" element={<Navigate to="/mentees/payment-detail" replace />} />
            <Route path="/teacherList" element={<Navigate to="/mentees/teacher-list" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default StudentLayout;
